import styled from "styled-components";
import { BaseButton } from "@shared/styles/common.styled";

export const SiteContainer = styled.section`
  font-family: Lato;
  font-style: normal;
  letter-spacing: 0;
`;

export const SectionContainer = styled.section`
  font-family: Lato;
  font-weight: 700;
  min-height: 100vh;
`;

export const FlexRow = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  > div {
    margin-right: 1rem;
  }
`;

export const MainWrapper = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  max-width: 75rem;
  padding: 1.875rem 0 3.625rem;
  position: relative;
`;

export const SiteInfoContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 6.25rem;
  width: 100%;
  justify-content: space-between;
`;

export const SiteSection = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  width: 47%;
`;

export const SiteWrapper = styled.div`
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 2px 4px 4px 0 rgba(0, 0, 0, 0.25);
  display: inline-flex;
  flex-direction: column;
  padding-bottom: 1.8125rem;
`;

export const CompanyContainer = styled.section`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  width: 47%;
`;
